import { AccessType, BaseDetailsDto, PermissionTypeEnum } from "@/sharedTypes/commonTypes";

export enum AccessRightsController {
	ACCESS_RIGHT_ENTRIES = "access-right-entries"
}

export enum AccessRightActionEndpoints {
	GRANT = `${AccessRightsController.ACCESS_RIGHT_ENTRIES}\\grant-access`,
	REVOKE = `${AccessRightsController.ACCESS_RIGHT_ENTRIES}\\revoke-access`,
	MANAGE = `${AccessRightsController.ACCESS_RIGHT_ENTRIES}\\manage-access`,
	GET_ELIGIBLE_EMPLOYEES = `${AccessRightsController.ACCESS_RIGHT_ENTRIES}\\get-eligible-employees`
}

export const PERMISSION_GROUP = "AccessRightsManagement";
export const ENTRIES_PERMISSION_SUBGROUP = "AccessRightEntries";
export const SUPER_ADMIN_ACCESS = "super-admin";

export type AccessModalData = {
	accessType: AccessType;
	entityIds?: string[];
};

export enum AccessRightsPermission {
	ACCESS_RIGHTS_ENTRIES = `${PERMISSION_GROUP}.${ENTRIES_PERMISSION_SUBGROUP}`
}

export enum AccessControlledEntityEnum {
	Case = 1,
	Act = 2,
	InternalAct = 3,
	Submission = 4,
	Document = 5
}

export enum AccessRightGrantedReasonEnum {
	Manual = 0,
	OrganizationalUnitHead = 1,
	OrganizationalUnitHeadReplacement = 2,
	AssignedToEmployee = 3,
	RegistryOfficeWorker = 4,
	BelongsToOrganizationalUnit = 5,
	CreatedByEmployee = 6,
	Migration = 7
}

export type HasAccessRightsRequest = {
	employeeId: string;
	entityId: string;
	accessRight: PermissionTypeEnum;
	accessControlledEntity: AccessControlledEntityEnum;
};

export type GrantAccessRightsRequest = {
	accessControlledEntity: AccessControlledEntityEnum;
	grantToEmployeeId: string;
	accessRight: PermissionTypeEnum;
	entityIDs?: string[];
	reason?: string;
	grantedByEmployeeId?: string;
	grantedByUserId?: string;
};

export type RevokeAccessRightsRequest = {
	accessRightIDs?: string[];
	reason?: string;
	revokedByEmployeeId?: string;
	revokedByUserId?: string;
};

export type ManageAccessRightsRequest = {
	accessRightId: string;
	accessRight: PermissionTypeEnum;
	reason?: string;
	grantedByEmployeeId?: string;
	grantedByUserId?: string;
};

export type GetEligibleEmployeesRequest = {
	entityId: string;
	keyword?: string;
};

export type AccessRightsRequest = GrantAccessRightsRequest | ManageAccessRightsRequest | RevokeAccessRightsRequest | GetEligibleEmployeesRequest;

export type AccessRightEntryDetailsDto = BaseDetailsDto & {
	entityId: string;
	accessControlledEntity: AccessControlledEntityEnum | null;
	employeeId: string;
	accessRight: PermissionTypeEnum | null;
	grantedByEmployeeId: string | null;
	grantedByUserId: string | null;
	grantedAt: string;
	revokedByEmployeeId: string | null;
	revokedByUserId: string | null;
	revokedAt: string | null;
	reasonForAccessGrant: AccessRightGrantedReasonEnum | null;
	reason: string | null;
	id: string;
};

export type AccessRightEntryFilterDto = {
	entityId: string;
	employeeId: string;
	accessRight: PermissionTypeEnum | null;
	reasonForAccessGrant: AccessRightGrantedReasonEnum | null;
};

export type AccessRightEntryGridDto = BaseDetailsDto & {
	entityId: string;
	accessControlledEntity: AccessControlledEntityEnum | null;
	workplaceTitle: string | null;
	employeeId: string;
	employeeFullName: string | null;
	accessRight: PermissionTypeEnum | null;
	grantedByEmployeeId: string | null;
	grantedByUserId: string | null;
	grantedByFullName: string | null;
	grantedAt: string;
	revokedByEmployeeId: string | null;
	revokedByUserId: string | null;
	revokedByFullName: string | null;
	revokedAt: string | null;
	reasonForAccessGrant: AccessRightGrantedReasonEnum | null;
	reason: string | null;
};

export type DummyCreateUpdateAccessRightDto = {
	id: string;
};
